const tiers = [5, 10, 25, 50, 100, 150, 200, 250, 300, 350];

export const roundSessionCount = (count: number): string => {
  let tier = "";
  for (const fixed_tier of tiers) {
    if (count >= fixed_tier) {
      tier = `${fixed_tier}+`;
    } else {
      return tier;
    }
  }
  return tier;
};
